// ==========================================
//  カードスウォッチ → サムネイル画像切り替え
// ==========================================
(function () {
  const CARD_SELECTORS = [
    '.cs-stina-collection__item',
    '.cs-ranking__item',
    '.retune-product-card',
  ].join(', ');

  const WIDTHS = [300, 400, 500, 600, 700, 800, 900, 1000];

  function toSized(src, width) {
    const sep = src.includes('?') ? '&' : '?';
    return src + sep + 'width=' + width;
  }

  document.addEventListener('change', function (e) {
    const input = e.target;
    if (!input.matches('input[type="radio"][data-variant-media]')) return;

    let media;
    try { media = JSON.parse(input.dataset.variantMedia); } catch (err) { return; }

    const card = input.closest(CARD_SELECTORS);
    if (!card) return;

    const img = card.querySelector('img');
    if (!img) return;

    const baseSrc = (media.preview_image || media).src;
    if (!baseSrc) return;

    img.style.opacity = '0';
    img.addEventListener('transitionend', function onFadeOut() {
      img.removeEventListener('transitionend', onFadeOut);
      img.src = toSized(baseSrc, 800);
      img.srcset = WIDTHS.map(function (w) { return toSized(baseSrc, w) + ' ' + w + 'w'; }).join(', ');
      img.style.opacity = '';
    }, { once: true });
  });
}());



/* ============================================================
   セクションのスクロール表示（フェード＋スライドアップ）
   ============================================================ */
(function () {
  'use strict';

  var SELECTOR = '#main > .shopify-section:not([class*="shopify-section-group-"])';
  var ATTR = 'data-cs-reveal';
  var observer = null;

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getObserver() {
    if (observer) return observer;

    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.setAttribute(ATTR, 'revealed');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });

    return observer;
  }

  function setup() {
    if (reducedMotion() || !('IntersectionObserver' in window)) return;

    var sections = document.querySelectorAll(SELECTOR);

    Array.prototype.forEach.call(sections, function (section) {
      if (section.hasAttribute(ATTR)) return;
      if (section.getBoundingClientRect().top < window.innerHeight) return;

      section.setAttribute(ATTR, 'pending');
      getObserver().observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.setAttribute) {
      event.target.setAttribute(ATTR, 'revealed');
    }
    setup();
  });
}());


/* ============================================================
   要素単位のスクロール表示（画面に入った行ごとにふわっと）
   data-cs-reveal-item="init" を持つ要素を個別に監視する。
   同じ行の要素は同じ高さにあるため同時に画面へ入り、行単位で同時に表示される。
   セクション単位の data-cs-reveal とは独立して動作する。
   ============================================================ */
(function () {
  'use strict';

  var ATTR = 'data-cs-reveal-item';
  var SELECTOR = '[' + ATTR + '="init"]';
  var observer = null;

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getObserver() {
    if (observer) return observer;

    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.setAttribute(ATTR, 'revealed');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });

    return observer;
  }

  function setup(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var items = scope.querySelectorAll(SELECTOR);
    var skipAnimation = reducedMotion() || !('IntersectionObserver' in window);

    Array.prototype.forEach.call(items, function (item) {
      if (skipAnimation) {
        item.setAttribute(ATTR, 'revealed');
        return;
      }

      /* 初期表示時点ですでに画面内にあるものはアニメーションさせない */
      if (item.getBoundingClientRect().top < window.innerHeight) {
        item.setAttribute(ATTR, 'revealed');
        return;
      }

      item.setAttribute(ATTR, 'pending');
      getObserver().observe(item);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setup(); });
  } else {
    setup();
  }

  /* テーマエディタでセクションを編集したときは即時表示にする */
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelectorAll) {
      Array.prototype.forEach.call(event.target.querySelectorAll(SELECTOR), function (item) {
        item.setAttribute(ATTR, 'revealed');
      });
    }
    setup();
  });
}());
